import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectedCount", "toggleModule", "toggleSection"]

  connect() {
    this.updateSelectedCount()
    this.syncToggleLabels()
  }

  toggleModule(event) {
    event.preventDefault()
    const moduleElement = event.currentTarget.closest("[data-module-filter-target='section']")
    if (!moduleElement) return

    this.toggleCheckboxes(this.checkboxesIn(moduleElement))
  }

  toggleSection(event) {
    event.preventDefault()
    const sectionElement = event.currentTarget.closest("[data-permission-bulk-select-target='section']")
    if (!sectionElement) return

    this.toggleCheckboxes(this.checkboxesIn(sectionElement))
  }

  checkboxChanged() {
    this.updateSelectedCount()
    this.syncToggleLabels()
  }

  toggleCheckboxes(checkboxes) {
    const selectable = checkboxes.filter((checkbox) => !checkbox.disabled)
    if (selectable.length === 0) return

    const shouldSelect = selectable.some((checkbox) => !checkbox.checked)
    selectable.forEach((checkbox) => {
      checkbox.checked = shouldSelect
    })

    this.updateSelectedCount()
    this.syncToggleLabels()
  }

  checkboxesIn(container) {
    return Array.from(container.querySelectorAll("input[type='checkbox'][name='access_role[access_permission_ids][]']"))
  }

  updateSelectedCount() {
    if (!this.hasSelectedCountTarget) return

    const selected = this.checkboxTargets.filter((checkbox) => checkbox.checked).length
    this.selectedCountTarget.textContent = selected.toString()
  }

  syncToggleLabels() {
    this.toggleModuleTargets.forEach((button) => {
      const moduleElement = button.closest("[data-module-filter-target='section']")
      if (!moduleElement) return

      button.textContent = this.toggleLabel(this.checkboxesIn(moduleElement))
    })

    this.toggleSectionTargets.forEach((button) => {
      const sectionElement = button.closest("[data-permission-bulk-select-target='section']")
      if (!sectionElement) return

      button.textContent = this.toggleLabel(this.checkboxesIn(sectionElement))
    })
  }

  toggleLabel(checkboxes) {
    const selectable = checkboxes.filter((checkbox) => !checkbox.disabled)
    if (selectable.length === 0) return this.selectAllLabel()

    const allSelected = selectable.every((checkbox) => checkbox.checked)
    return allSelected ? this.deselectAllLabel() : this.selectAllLabel()
  }

  selectAllLabel() {
    return this.element.dataset.permissionBulkSelectSelectAllValue || "Select all"
  }

  deselectAllLabel() {
    return this.element.dataset.permissionBulkSelectDeselectAllValue || "Deselect all"
  }
}
